export const localStorageKeys = Object.freeze({
  TIMECARD_DATE: 'TIMECARD_DATE',
  TIMECARD_DICTIONARY: 'TIMECARD_DICTIONARY',
  TIMECARD_AMOUNT: 'TIMECARD_AMOUNT',
  TIMECARD_DEDUCTIONS: 'TIMECARD_DEDUCTIONS',
  TIMECARD_PAYRATES_AND_WAGES: 'TIMECARD_PAYRATES_AND_WAGES',
  TIMECARD_ORGDATA: 'TIMECARD_ORGDATA',
  PUNCH_CATEGORIES_LONG_NAME: 'PUNCH_CATEGORIES_LONG_NAME',
  PUNCH_CATEGORIES_UNPAID_NAME: 'PUNCH_CATEGORIES_UNPAID_NAME',
  CLOCK_STATUS_FIRMWARE_VERSION: 'CLOCK_STATUS_FIRMWARE_VERSION',
  CLOCK_STATUS_SOFTWARE_VERSION: 'CLOCK_STATUS_SOFTWARE_VERSION',
  CLOCK_STATUS_ACTIVATION_DATE: 'CLOCK_STATUS_ACTIVATION_DATE',
  WEBCLOCK_OFFLINE_PUNCH_QUEUE_PREFIX: 'WEBCLOCK_OFFLINE_PUNCH_QUEUE',
  WEBCLOCK_CLOCK_CONNECT_CACHE_PREFIX: 'WEBCLOCK_CLOCK_CONNECT_CACHE',
  // Add more keys as needed
});

export const sessionStorageKeys = Object.freeze({
  TIMECARD_DATE: 'TIMECARD_DATE',
  TIMECARD_DICTIONARY: 'TIMECARD_DICTIONARY',
  ACCRUAL_POLICY: 'ACCRUAL_POLICY',
  ACCRUAL_DO_NOT_SHOW_FOR_EDIT: 'ACCRUAL_DO_NOT_SHOW_FOR_EDIT',
  ACCRUAL_DO_NOT_SHOW_FOR_GO_BACK:
    'ACCRUAL_DO_NOT_SHOW_FOR_GO_BACK_TO_POLICIES',
  TOKEN: 'TOKEN',
  SCHEDULE_ADD_SHIFT_NOT_PUBLISHED: 'SCHEDULE_ADD_SHIFT_NOT_PUBLISHED',
  SHOW_READ_RECEIPTS: 'SHOW_READ_RECEIPTS',
  // Add more keys as needed
});
